import { Check, ChevronRight } from "lucide-react";

const FinalCtaSection = ({ onOpenModal, onOpenSketch }) => {
  const chips = ["Átlátható folyamat", "Prémium megjelenés", "Mobilon is ütős"];

  return (
    <section data-testid="final-cta-section" className="dark-section py-24 md:py-32 relative overflow-hidden" aria-label="Weboldal készítés indítása">
      <div className="blur-blob blur-blob-1" aria-hidden="true" />
      <div className="blur-blob blur-blob-2" aria-hidden="true" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="scroll-animate font-sora font-bold text-4xl sm:text-5xl lg:text-6xl text-on-dark">
          Kezdjük a profi{" "}
          <span className="text-gradient">weboldal készítést</span>
        </h2>

        <p className="scroll-animate mt-6 text-on-dark/70 text-base sm:text-lg max-w-2xl mx-auto">
          Nem kell túltervezni a honlap készítést. Nem kell hónapokig ülni rajta.
          <br />
          Kell egy prémium ügyfélszerző oldal, ami tisztán kommunikál — és amin a látogató tudja, mit tegyen.
        </p>

        <div className="scroll-animate flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <button
            onClick={onOpenModal}
            className="bg-gradient-to-r from-primary to-accent text-white rounded-full px-8 py-4 font-semibold shadow-glow hover:shadow-glow-lg transition-all btn-glow"
            data-testid="final-primary-cta"
          >
            Kérek egy gyors ajánlatot
            <ChevronRight className="inline ml-2" size={18} />
          </button>
          <button
            onClick={onOpenSketch}
            className="bg-white/10 hover:bg-white/15 text-on-dark border border-white/20 rounded-full px-8 py-4 font-medium transition-all"
            data-testid="final-secondary-cta"
          >
            Kérdésem van
          </button>
        </div>

        <div className="scroll-animate flex flex-wrap justify-center gap-3 mt-10">
          {chips.map((chip, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-on-dark/80 text-sm"
            >
              <Check className="inline mr-2" size={14} />
              {chip}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalCtaSection;
